import { render, staticRenderFns } from "./AppVideoBanner.vue?vue&type=template&id=f1b9d24a&scoped=true"
import script from "./AppVideoBanner.vue?vue&type=script&lang=ts"
export * from "./AppVideoBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b9d24a",
  null
  
)

export default component.exports